'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));
var utils_js = require('../helpers/utils.js');

function getTimeRemaining(endtime) {
  var t = Date.parse(endtime) - Date.parse(new Date());
  var seconds = Math.floor(t / 1000 % 60);
  var minutes = Math.floor(t / 1000 / 60 % 60);

  return {
    total: t,
    minutes: Math.max(minutes, 0),
    seconds: Math.max(seconds, 0)
  };
}

function initializeClock(el, endtime) {
  var $el = utils_js.isJquery(el) ? el : $(el);
  var timeToEnd = endtime || nextInterval();
  var $minutesSpan = $el.find('.minutes');
  var $secondsSpan = $el.find('.seconds');
  var timeinterval = setInterval(updateClock, 1000);

  function updateClock() {
    var t = getTimeRemaining(timeToEnd);

    $minutesSpan.text(('0' + t.minutes).slice(-2));
    $secondsSpan.text(('0' + t.seconds).slice(-2));

    if (t.total <= 1) {
      // Stop the countdown at 1 second
      $secondsSpan.text('01');
      clearInterval(timeinterval);
    }
  }

  updateClock();
}

function nextInterval() {
  var next = new Date();
  var mins = next.getMinutes();
  var quarterHours = mins % 15 === 0 ? Math.ceil(mins / 15) + 1 : Math.ceil(mins / 15);

  if (quarterHours === 4) {
    next.setHours(next.getHours() + 1);
  }

  var rounded = quarterHours * 15 % 60;

  next.setMinutes(rounded);
  next.setSeconds(0);

  return next;
}

// eslint-disable-next-line import/no-anonymous-default-export
var countdown = {
  initializeClock: initializeClock
};

module.exports = countdown;
